import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { IRequestCallback, IRequestCallbackFunction, IRequestOptions } from '@df/api/request/request.service';
import { Client } from '@df/core/service/client';
import { Status } from '@df/core/status';
import { IAddToBasketData } from '@df/session/api/basket/basket';
import {
    BASKET_ADD_SUCCESS_EVENT,
    BASKET_ASS_SUCCESS_UPDATE_EVENT,
    BasketService,
    IAddToBasketEventHandle,
    IAddToBasketRequestData,
    IAddToBasketSuccessEventData,
    IResponseAddToBasket
} from '@df/session/api/basket/basket.service';
import { ModalService } from '@df/ui/modal/modal.service';
import { NModalLayoutRight } from '../ui/modal/modal-layout-right.component';
import { BasketAddConfirmationModal } from './basket-add-confirmation-modal/basket-add-confirmation-modal.component';

@Injectable({
    providedIn: 'root'
})
export class LocalBasketService extends BasketService {
    router = inject(Router);

    protected modalService = inject(ModalService);

    protected client = inject(Client);

    override add(
        status: Status | undefined,
        addToBasketData: IAddToBasketData | IAddToBasketData[] | number | string | undefined,
        onSuccess?: IRequestCallbackFunction,
        onError?: IRequestCallback
    ): Promise<IResponseAddToBasket> | void {
        const products = this.normalizeAddToBasketData(addToBasketData);
        if (!products) {
            return;
        }
        const requestData: IAddToBasketRequestData = { products };
        const requestOptions: IRequestOptions = {};
        const handle: IAddToBasketEventHandle = {
            continue: true,
            requestOptions,
            proceed: (): Promise<any> | void => {
                return this.request.send(
                    status,
                    () => this.request.nexus.basket.add(requestData),
                    result => {
                        if (onSuccess) {
                            result = onSuccess(result);
                        }
                        const eventData: IAddToBasketSuccessEventData = {
                            request: requestData,
                            response:
                                this.app.ab.getVariant('addToBasket') === 'A' || this.app.ab.getVariant('addToBasket') === 'C'
                                    ? result
                                    : { ...result, preventMinibasketOpen: true }
                        };
                        this.addToBasketSuccessSubject.next(eventData);
                        this.events.broadcast(BASKET_ADD_SUCCESS_EVENT, eventData);
                        const basketSubscribe = this.app.customer.basket.subscribe(() => {
                            basketSubscribe.unsubscribe();
                            this.addToBasketSuccessUpdateSubject.next(eventData);
                            this.events.broadcast(BASKET_ASS_SUCCESS_UPDATE_EVENT, eventData);
                        });

                        if (this.app.ab.getVariant('addToBasket') === 'B') {
                            this.router.navigate(['/basket']);
                        } else if (this.app.ab.getVariant('addToBasket') === 'C' && (this.client.isS || this.client.isM)) {
                            this.modalService.open(BasketAddConfirmationModal, {
                                ...NModalLayoutRight.ModalConfig,
                                width: '100%',
                                height: '100%',
                                modalClass: 'bg-col-w p-a-4-s p-t-7-s'
                            });
                        }
                        return result;
                    },
                    onError,
                    requestOptions
                );
            }
        };

        this.addToBasketBeforeSubject.next({ requestData, handle });

        // send add to basket request
        if (handle.continue) {
            return handle.proceed();
        }
    }
}
